export const RegexConfig = Object.freeze({
})